<template lang="html">
  <div v-if="hasVorlagen()" class="small-12 large-9 column mb-5 mb-6@large">
    <h2>{{ 'txtDownloadTemplateDetailTitle' | translate }}</h2>
    <div class="download bg-shade-light my-children-prj2 px-prj py-1 px-prj2">
      <div class="download__container my-children-prj">
        <template v-for="vorlage in this.vorlagen">
          <a :href="vorlage.token"
             class="content-list d-flex align-items-center bg-white text-decoration-none text-shade-darker" download
             v-if="canDisplayVorlage( vorlage )">
            <figure
                class="content-list__figure bg-shade embed-responsive embed-responsive-1/1 position-relative flex-child-fix">
              <img :src="vorlage.iconUrl"
                   height="60" width="60"
                   class="svg-icon object-fit-contain position-absolute t-0 l-0"
                   v-if="vorlage.token">
              <template v-else>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"
                     class="svg-icon object-fit-contain position-absolute t-0 l-0">
                  <path
                      d="M39.8 47.6c1.2 0 2.2-1 2.2-2.2V14.6c0-1.2-1-2.2-2.2-2.2H23.9c-.9 0-2 .5-2.7 1.1L15 19.7c-.6.6-1.1 1.8-1.1 2.7v23.1c0 1.2 1 2.2 2.2 2.2h23.7zm0-33v30.8H16.2V22.3h5.5c1.2 0 2.2-1 2.2-2.2v-5.5h15.9zm-18.1 1.5v4h-4l4-4z"
                      fill="#fff"/>
                </svg>
              </template>
						</figure>
						<div class="content-list__desc d-block mx-prj2 line-height-14">
              <span class="font-weight-bold" v-if="vorlage.name">{{ vorlage.name }}</span>
						</div>
						<div class="content-list__btn btn btn--prj-min-x ml-auto mr-prj2 show-for-medium" :title="getDownloadTitle()">
							<template>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.92 12.76" class="svg-icon fill-white text-xsmall position-relative tn-1px mr-2"><path d="M.75 12.76a1 1 0 01-.51-.28.85.85 0 01-.24-.6V9a.85.85 0 011.19-.81.84.84 0 01.54.84v1.82c0 .14 0 .14.13.14h8.2c.13 0 .13 0 .13-.13V9.09a.87.87 0 01.36-.75.82.82 0 01.85-.09.8.8 0 01.51.67 1.21 1.21 0 010 .19v2.72a.89.89 0 01-.24.66.94.94 0 01-.43.25h-.08z" fill="#3a3a39" fill-rule="evenodd"/><path d="M6.19 0a2.43 2.43 0 01.37.16.84.84 0 01.38.73v5.42l.22-.21c.3-.3.6-.61.91-.91a.85.85 0 011.07-.11.87.87 0 01.34 1 1.26 1.26 0 01-.35.47L7.72 8 6.65 9a.88.88 0 01-1.24 0L3.78 7.34c-.33-.33-.67-.66-1-1a.8.8 0 01-.13-.85.85.85 0 01.69-.49 1 1 0 01.85.35c.31.32.62.62.93.93l.08.07V1a.93.93 0 01.21-.69.87.87 0 01.46-.31H6z" fill="#3a3a39" fill-rule="evenodd"/></svg>
							</template>
							{{ 'txtDownload' | translate }}
						</div>
					</a>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import {translatePrj} from "classes/vue-dict-filter.js";

export const ATTRIBUTE_TYPE_ID = 1;

    export default {
      components: {},
      mixins: [],
      props: ['vorlagen'],
      inject: ['globalConfig', 'optionsService', 'configuratorService'],
      methods: {
        hasVorlagen() {
          if (this.vorlagen?.length <= 0) {
            return false
          }

          return true
        },
        canDisplayVorlage(vorlage) {
          const selectedConfigs = this.configuratorService.observableData.data.configgroups.flatMap(x => x.konfigurationsmoeglichkeiten).flatMap(x => x.auspraegungen).filter(x => x.status === 'SELECTED').map(x => x.id)
          return vorlage.auspraegungsIds.filter(x => x > 0).every(x => selectedConfigs.includes(x))

        },
          getDownloadTitle () {
            return `${translatePrj( 'txtDownload' )} ${this.globalConfig.product_name}`
          },
        }
    };
</script>
